<template>
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 2000">
		<div style="width: 600px; min-height: 400px">
			<div class="dialog-header" style="height: 15%">
				<span style="font-size: 18px; width: 40%; margin-top: auto; margin-bottom: auto">{{
					$t("add-folder")
				}}</span>
				<div style="width: 60%; display: flex; justify-content: flex-end; padding: 5px">
					<div class="close-btn" @click="$emit('close', false)">
						<md-icon style="color: #fff">close</md-icon>
						<span style="padding-left: 5px">{{ $t("cancel") }}</span>
					</div>
					<button @click="save" :disabled="!selected_folder" class="add-btn">
						<i class="el-icon-loading" v-if="loading" />
						<md-icon style="color: #fff">save</md-icon>
						<span style="padding-left: 5px; font-weight: 900">{{ $t("save") }}</span>
					</button>
					<!-- <md-button @click="$emit('close', false)" class="md-icon-button">
						<md-icon style="color: white">close</md-icon>
						<span>{{ $t("cancel") }}</span>
					</md-button>
					<md-button class="add" @click="save" :disabled="!selected_folder">
						<i class="el-icon-loading" v-if="loading" />
						<md-icon style="color: #fff">save</md-icon>
						<span>{{ $t("save") }}</span>
					</md-button> -->
				</div>
			</div>
			<!-- <div class="dialog-footer">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="$emit('close', false)">
						{{ $t("cancel") }}
					</md-button>
					<md-button class="add" @click="save" :disabled="!selected_folder">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ $t("save") }}</span>
					</md-button>
				</div>
			</div> -->
			<div class="dialog-body" style="min-height: 85% !important">
				<div class="container">
					<div class="c1">
						<div class="text">
							{{ $t("add-folder-2") }}
						</div>
						<div class="help">
							{{ $t("need-help-request") }}
							<el-button @click="openWizard = true">{{ $t("add-folder") }}</el-button>
							<el-button @click="openWizard2 = true"> {{ $t("add-doc2") }} </el-button>
						</div>

						<wizard-modal
							@add="valuetoadd => addtosel(valuetoadd)"
							v-if="openWizard"
							:show="openWizard"
							:wizard_id="2"
							@close="
								() => {
									openWizard = false
								}
							"
						></wizard-modal>
						<wizard-modal
							@add="valuetoadd => addtosel2(valuetoadd)"
							v-if="openWizard2"
							:show="openWizard2"
							:wizard_id="1"
							@close="
								() => {
									openWizard2 = false
								}
							"
						></wizard-modal>

						<div>
							<div style="display: flex; width: 100%; justify-content: flex-end">
								<div class="show-filters" @click="showFilters = !showFilters">
									{{ showFilters ? $t("close-advanced-search") : $t("open-advanced-search") }}
									<md-icon>{{ showFilters ? "remove_circle_outline" : "control_point" }}</md-icon>
								</div>
							</div>

							<search
								v-if="showFilters && preloaded"
								:preloadFilters="preloaded"
								:alwaysShowFilters="true"
								:loadDocs="false"
								:loadFolders="true"
								:folderID="undefined"
								:schoolID="$route.params.school_id"
								from="add-folder"
								@docSelected="item => {}"
								@folderSelected="
									item => {
										selected_folder = item.id
									}
								"
								@keyup="str => {}"
							/>
							<div v-if="!showFilters">
								<div v-if="loading_data" style="text-align: center">
									{{ $t("searching-folder") }} <br />
									<i class="el-icon-loading" />
								</div>
								<div v-else>
									<el-select
										v-model="selected_folder"
										:placeholder="$t('folders-search')"
										style="width: 100%"
										filterable
										:loading="loading_data"
										:reserve-keyword="true"
									>
										<el-option
											v-for="folder in folders"
											:key="folder.folder.id"
											:label="folder.folder.name"
											:value="folder.folder.id"
										></el-option>
									</el-select>
								</div>
							</div>
						</div>
					</div>
					<div class="c2" v-if="selected_docs.length">
						<span>{{ $t("add-folder-3") }}</span>
						<div>
							<el-select
								v-model="selected_docs"
								multiple
								:placeholder="$t('documents-search')"
								style="width: 100%"
								filterable
								:reserve-keyword="true"
							>
								<el-option
									v-for="doc in docs"
									:key="doc.id"
									:label="doc.title"
									:value="doc.id"
								></el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import Search from "@/modules/browse/components/search"
import WizardRender from "@/modules/wizard/modals/wizard-render"
import WizardModal from "@/modules/wizard/modals/wizard-modal"

export default {
	name: "add-folder",
	components: {
		WizardRender,
		WizardModal,
		Search
	},
	props: ["project_id", "show"],
	data() {
		return {
			loading: false,
			selected_docs: [],
			selected_folder: [],
			folders: [],
			preloaded: [],
			docs: [],
			showFilters: false,
			openWizard: false,
			openWizard2: false,
			MAX_DOCS: 20,
			loading_data: true
		}
	},
	computed: mapState("organization", ["numberOfCreatedDocuments"]),
	watch: {
		selected_folder() {
			if (this.selected_folder) {
				this.docs = this.folders.filter(item => item.folder.id == this.selected_folder)[0].docs
				if (this.docs) this.selected_docs = this.docs.map(item => item.id)
				else this.selected_docs = []
			} else {
				this.selected_docs = []
			}
		}
	},
	created() {
		this.getFolders()
	},
	methods: {
		addtosel(val) {
			this.selected_folder = []

			this.selected_folder = val.id
			this.openWizard = false
		},
		addtosel2(val) {
			this.showFilters = true
			this.preloaded = undefined
			this.preloaded = "tag_" + val.id
			this.openWizard2 = false
		},
		...mapMutations({
			updateCreatedDocuments: "organization/UPDATE_CREATED_DOCUMENTS",
			updateCreatedProcedures: "organization/UPDATE_CREATED_PROCEDURES"
		}),
		getFolders() {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/folders/getBySubscription",
					{
						organization_id: this.$route.params.school_id
					},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(({ data: { items } }) => {
					this.folders = items
					this.loading_data = false
				})
				.catch(err => {
					this.loading_data = false
					console.error(err)
				})
		},
		save() {
			if (!this.selected_folder) return

			// if (this.numberOfCreatedDocuments + this.selected_docs.length > this.MAX_DOCS)
			// 	return this.$notification(
			// 		"warning",
			// 		this.$t("warning-max-documents-created", {
			// 			number: this.MAX_DOCS - this.numberOfCreatedDocuments
			// 		}),
			// 		"",
			// 		5000
			// 	)

			this.loading = true

			const url = `${process.env.VUE_APP_API_URL}/api/projects/add`
			const payload = {
				name: this.folders.find(item => item.folder.id == this.selected_folder).folder.name,
				project_id: this.project_id,
				folder_id: this.selected_folder,
				organization_id: this.$route.params.school_id
			}

			axios
				.post(url, payload, { headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } })
				.then(({ data: project }) => {
					this.selected_folder = undefined
					this.updateCreatedProcedures(1)

					let payload = {
						project_id: project.id,
						flowcharts: this.selected_docs,
						organization_id: this.$route.params.school_id
					}
					axios
						.post(process.env.VUE_APP_API_URL + "/api/documents/add", payload, {
							headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
						})
						.then(({ data: documents }) => {
							this.$emit("close", project)
							this.updateCreatedDocuments((documents || []).length)
							this.selected_docs = []
						})
						.catch(({ response }) => {
							const {
								data: { Message: translationKeys = [] }
							} = response

							translationKeys.forEach(key => this.$notification("error", this.$t(key), "", 0))
						})
						.finally(() => (this.loading = false))
				})
				.catch(err => {
					this.loading = false
					this.$processError(this.$t("save-error"), err.response.data.Message)
				})
		}
	}
}
</script>

<style scoped lang="scss">
.show-filters {
	font-size: small;
	color: grey;
	font-style: italic;
	text-align: right;
	width: 50%;
	cursor: pointer;
	margin-top: 5px;
}

.dialog-body {
	margin-bottom: 0 !important;
}

.container {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	.c1 {
		height: 60%;

		.help {
			padding-top: 5px;
			padding-bottom: 5px;
			display: flex;
			justify-content: center;
		}
	}

	.c2 {
		height: 40%;
		padding-top: 15px;
	}
}

.close-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	&:hover {
		i,
		span {
			font-weight: 900;
		}
	}
}

.add-btn {
	display: flex;
	border: none;
	align-items: center;
	background-color: #00a95d;
	padding: 10px;
	margin-left: 20px;
	border-radius: 7px;
	cursor: pointer;
	&:hover {
		background-color: #00c06a;
	}
	&.disabled {
		background-color: #029754;
	}
}
</style>
